import { createFileRoute } from '@tanstack/react-router';
import { PortalInvoices } from '@/features/portal/PortalInvoices';

export const Route = createFileRoute('/_portal/portal/fatture')({ component: PortalInvoices });
